import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations.ts';

import { getSSRRenderInputs } from '@confluence/ssr-utilities/entry-points/ssrRenderInputs.ts';

const STABLE_UI_PARAM = 'stableUI=1';

/**
 * To be used by E2E/playwright/Criterion tests, to ensure UI is predictable upon the initial load:
 *  - the side nav is always expanded to its default width
 *  - no changeboarding dialogs are shown
 *  - no banners are shown
 */
export const isStableUIEnabledForTests = () => {
	if (StatsigConfigurations.isKillSwitchOn('cc_e2e_stable_ui')) {
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		return process.env.REACT_SSR
			? getSSRRenderInputs().uri.includes(STABLE_UI_PARAM)
			: window.location.search.includes(STABLE_UI_PARAM);
	}

	return false;
};
